export function EditorialPageHeader({
  eyebrow = "",
  title,
  description = "",
  meta = null,
  actions = null,
  className = ""
}) {
  return (
    <header className={["editorial-header", className].join(" ").trim()}>
      <div className="min-w-0 flex-1 space-y-3">
        {eyebrow ? <p className="editorial-header-eyebrow">{eyebrow}</p> : null}
        <div className="space-y-2">
          <h1 className="editorial-header-title">{title}</h1>
          {description ? <p className="editorial-header-description">{description}</p> : null}
        </div>
        {meta ? <div className="editorial-header-meta">{meta}</div> : null}
      </div>
      {actions ? <div className="editorial-header-actions">{actions}</div> : null}
    </header>
  );
}
